export default __webpack_public_path__ + "static/media/pc.f44e5f39.svg";